import { apiCall } from "../api/base";
import type { LoaderValidationOutboxRow } from "./loaderValidationOutbox";

export interface LoaderValidationSubmitResponse {
  job_id: string;
  loader_job_id: string;
  status: string;
}

export async function submitLoaderValidationRow(
  row: LoaderValidationOutboxRow,
): Promise<LoaderValidationSubmitResponse> {
  return (await apiCall("/conversion/loader-validation-log", {
    method: "POST",
    keepalive: true,
    body: JSON.stringify({
      source_conversion_job_id: row.sourceConversionJobId,
      loaded_vse_gcs_path: row.loadedVseGcsPath,
      loader_job_id: row.loaderJobId,
      generation: row.generation,
      outcome: row.outcome,
      worker_fragment: row.workerFragment,
    }),
  })) as LoaderValidationSubmitResponse;
}
